import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "use", "orientation"];
import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const UIButtonGroup = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      className,
      use,
      orientation
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const classes = classNames("UIButtonGroup private-button__group", className, use === 'floating' && 'private-floating-button-group__buttons private-floating-button-group__buttons--standalone', {
    'horizontal': 'private-button__group--horizontal',
    'vertical': 'private-button__group--vertical'
  }[orientation]);
  return /*#__PURE__*/_jsx("div", Object.assign({}, rest, {
    ref: ref,
    className: classes,
    role: "group",
    children: children
  }));
});
UIButtonGroup.propTypes = {
  children: PropTypes.node,
  use: PropTypes.oneOf(['default', 'floating']).isRequired,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};
UIButtonGroup.defaultProps = {
  use: 'default',
  orientation: 'horizontal'
};
UIButtonGroup.displayName = 'UIButtonGroup';
export default UIButtonGroup;